export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13415.1c7371e7.jpg";